<div class="p-4 md:p-6 max-w-5xl mx-auto">
  <!-- Header -->
  <div class="flex items-center gap-3 mb-6">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">trending_up</mat-icon>
    <h1 class="text-xl md:text-2xl font-bold text-gray-800">RAIL COLOMBIA — USD/COP: mercado vs Vita</h1>
  </div>

  <!-- Tasas actuales: mercado (Wise) + tasa pública de Vita + spread -->
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
    <!-- Mercado (Wise) -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">show_chart</mat-icon>
          Mercado (Wise)
        </h2>
      </div>
      <div class="p-5 flex flex-col items-center gap-2" *ngIf="mercado; else sinMercado">
        <p class="text-3xl font-bold" style="color: #1e5a3f;">{{ mercado.tasa | number:'1.2-4' }}</p>
        <span class="text-xs text-gray-400 uppercase font-semibold">USD / COP</span>
        <span class="text-xs text-gray-500">Fuente: <strong>{{ fuenteLabel(mercado.fuente) }}</strong></span>
        <span class="text-xs text-gray-500">Colombia: {{ mercado.fechaHoraColombia }}</span>
        <span class="text-xs text-gray-400">UTC: {{ mercado.fechaHoraUtc | date:'dd/MM/yyyy HH:mm':'UTC' }}</span>
        <span class="text-xs" *ngIf="mercado.variacionPct != null"
          [style.color]="(mercado.variacionPct >= 0) ? '#1e5a3f' : '#b91c1c'">
          Δ {{ mercado.variacionPct | number:'1.2-2' }}%
        </span>
      </div>
      <ng-template #sinMercado>
        <div class="p-5 flex flex-col items-center gap-1 text-gray-400">
          <mat-icon style="font-size: 28px; width: 28px; height: 28px;">cloud_off</mat-icon>
          <span class="text-xs">Sin dato de mercado todavía</span>
        </div>
      </ng-template>
    </div>

    <!-- Tasa pública de Vita -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div style="background: linear-gradient(135deg, #eff6ff, #eef2ff); padding: 16px 24px; border-bottom: 2px solid #bfdbfe;">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e3a8a; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #2563eb;">public</mat-icon>
          Tasa pública de Vita
        </h2>
      </div>
      <div class="p-5 flex flex-col items-center gap-2" *ngIf="vita; else sinVita">
        <p class="text-3xl font-bold" style="color: #1e3a8a;">{{ vita.tasa | number:'1.2-4' }}</p>
        <span class="text-xs text-gray-400 uppercase font-semibold">USD / COP</span>
        <span class="text-xs text-gray-500">Fuente: <strong>{{ fuenteLabel(vita.fuente) }}</strong></span>
        <span class="text-xs text-gray-500">Colombia: {{ vita.fechaHoraColombia }}</span>
        <span class="text-xs text-gray-400">UTC: {{ vita.fechaHoraUtc | date:'dd/MM/yyyy HH:mm':'UTC' }}</span>
        <span class="text-xs" *ngIf="vita.variacionPct != null"
          [style.color]="(vita.variacionPct >= 0) ? '#1e3a8a' : '#b91c1c'">
          Δ {{ vita.variacionPct | number:'1.2-2' }}%
        </span>
      </div>
      <ng-template #sinVita>
        <div class="p-5 flex flex-col items-center gap-1 text-gray-400">
          <mat-icon style="font-size: 28px; width: 28px; height: 28px;">cloud_off</mat-icon>
          <span class="text-xs">Sin dato de Vita todavía</span>
        </div>
      </ng-template>
    </div>

    <!-- Spread mercado vs Vita -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div style="background: linear-gradient(135deg, #fffbeb, #fef3c7); padding: 16px 24px; border-bottom: 2px solid #fde68a;">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #92400e; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #d97706;">compare_arrows</mat-icon>
          Spread (mercado − Vita)
        </h2>
      </div>
      <div class="p-5 flex flex-col items-center gap-2"
        *ngIf="spreadCop != null && spreadPct != null; else sinSpread">
        <p class="text-3xl font-bold" [style.color]="(spreadCop >= 0) ? '#92400e' : '#b91c1c'">
          {{ spreadCop | number:'1.2-2' }}
        </p>
        <span class="text-xs text-gray-400 uppercase font-semibold">COP por USD</span>
        <span class="text-sm font-semibold" [style.color]="(spreadPct >= 0) ? '#92400e' : '#b91c1c'">
          {{ spreadPct | number:'1.2-2' }}% bajo mercado
        </span>
        <span class="text-xs text-gray-500 text-center">
          Vita paga {{ spreadCop | number:'1.2-2' }} COP menos por USD que el mercado.
        </span>
      </div>
      <ng-template #sinSpread>
        <div class="p-5 flex flex-col items-center gap-1 text-gray-400">
          <mat-icon style="font-size: 28px; width: 28px; height: 28px;">remove</mat-icon>
          <span class="text-xs">Faltan datos de alguna fuente</span>
        </div>
      </ng-template>
    </div>

    <!-- Acción: forzar consulta -->
    <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
      <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
        <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">bolt</mat-icon>
          Consulta manual
        </h2>
      </div>
      <div class="p-5 flex flex-col items-center gap-3">
        <p class="text-xs text-gray-500 text-center">
          El cron consulta ambas fuentes cada 5 min. Solo se guarda una fila por fuente si su tasa cambió.
        </p>
        <button type="button" (click)="forzarConsulta()" [disabled]="refreshing"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">bolt</mat-icon>
          {{ refreshing ? 'Consultando...' : 'Forzar consulta' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Historial -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;"
      class="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">history</mat-icon>
        Historial de tasas USD/COP
      </h2>
      <div class="flex items-center gap-2">
        <!-- Filtro por fuente -->
        <select [(ngModel)]="filtroFuente" (change)="aplicarFiltro()"
          style="padding: 6px 12px; border: 1px solid #d1d5db; border-radius: 10px; font-size: 0.8rem; font-weight: 600; color: #374151; background: white; cursor: pointer;">
          <option value="">Todas las fuentes</option>
          <option value="WISE">Mercado (Wise)</option>
          <option value="INVESTING">Mercado (Investing, histórico)</option>
          <option value="VITA_PUBLIC">Tasa pública de Vita</option>
        </select>
        <button type="button" (click)="load()"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 6px 16px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.8rem; cursor: pointer; transition: all 0.2s ease;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">refresh</mat-icon>
          Refrescar
        </button>
      </div>
    </div>

    <div class="px-4 pt-2">
      <mat-paginator
        [pageSize]="25"
        [showFirstLastButtons]="true"
        [pageSizeOptions]="[10, 25, 50, 100]"
        aria-label="Seleccionar página">
      </mat-paginator>
    </div>

    <!-- Tabla Desktop -->
    <div class="hidden lg:block overflow-x-auto" *ngIf="dataSource">
      <table mat-table [dataSource]="dataSource" class="w-full">
        <ng-container matColumnDef="fechaUtc">
          <th mat-header-cell *matHeaderCellDef>Fecha/Hora UTC</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs">{{ row.fechaHoraUtc | date:'dd/MM/yyyy HH:mm':'UTC' }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="horaColombia">
          <th mat-header-cell *matHeaderCellDef>Hora Colombia</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs">{{ row.fechaHoraColombia }}</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="tasa">
          <th mat-header-cell *matHeaderCellDef>Tasa (USD/COP)</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs font-bold" style="color: #1e5a3f;">
              {{ row.tasa ? (row.tasa | number:'1.2-4') : '' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="variacion">
          <th mat-header-cell *matHeaderCellDef>Variación</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs" *ngIf="row.variacionPct != null"
              [style.color]="(row.variacionPct >= 0) ? '#1e5a3f' : '#b91c1c'">
              {{ row.variacionPct | number:'1.2-2' }}%
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="fuente">
          <th mat-header-cell *matHeaderCellDef>Fuente</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs">{{ fuenteLabel(row.fuente) }}</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <!-- Cards Mobile -->
    <div class="lg:hidden space-y-3 p-4" *ngIf="dataSource">
      <div *ngFor="let row of dataSource.filteredData"
        class="bg-white rounded-xl shadow-sm border border-gray-200 p-3">
        <div class="flex items-center justify-between">
          <div class="text-xs text-gray-500">
            <span class="font-semibold">{{ row.fechaHoraColombia }}</span>
            <span class="block text-gray-400">{{ fuenteLabel(row.fuente) }}</span>
          </div>
          <div class="text-right">
            <span class="text-sm font-bold" style="color: #1e5a3f;">
              {{ row.tasa ? (row.tasa | number:'1.2-4') : '' }}
            </span>
            <span class="block text-xs" *ngIf="row.variacionPct != null"
              [style.color]="(row.variacionPct >= 0) ? '#1e5a3f' : '#b91c1c'">
              {{ row.variacionPct | number:'1.2-2' }}%
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
